import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Partido } from 'src/app/models/partido';
import { Quiniela } from 'src/app/models/quiniela';
import { QuinielaJugada } from 'src/app/models/quiniela-jugada';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { PartidosService } from 'src/app/services/partidos.service';
import { QuinielaJugadaService } from 'src/app/services/quiniela-jugada.service';
import { Jugador } from 'src/app/models/jugador';
import { JugadorService } from 'src/app/services/jugadores.service';
import { DocumentSnapshot } from '@angular/fire/firestore';

@Component({
  selector: 'app-mostrar-quiniela',
  templateUrl: './mostrar-quiniela.component.html',
  styleUrls: ['./mostrar-quiniela.component.css']
})
export class MostrarQuinielaComponent implements OnInit {
  //donde se van a guardar los partidos del jugador
  partidosByJugador: Array<QuinielaJugada> = [];
  partidosByJugadorMOD:any=[]
  jugador: Jugador
  idQuiniela: string;
   partidosJugados = new Map();
  quiniela: Quiniela = null;
  isLoading = true;
  
  constructor(private rutaActiva: ActivatedRoute,
    private QuinielasService: QuinielasService,
    private PartidosService: PartidosService,
    private QuinielaJugadaService: QuinielaJugadaService,
    private router: Router,
    private jugadorService: JugadorService,
    private toastr: ToastrService,) { }
   
  ngOnInit(): void {
    var idJugador = this.rutaActiva.snapshot.params.id;

    this.getJugador(idJugador)
  }
/**
 * obtengo todos los partidos de una quiniela para saber si ya se jugo o no
 * @param idQuiniela id de la quiniela para un cambio en la vista.
 */
getPartidos(idQuiniela){
  this.PartidosService.getAllPartidosByIdQuiniela(idQuiniela).subscribe((items) => {
    // Setting up partidos
    var partidos = items.map(
      (item) =>
      ({
        ...item.payload.doc.data(),
        $key: item.payload.doc.id,
      } as Partido)
    );
   
    partidos.forEach(element => {
      if(element.resultado1!=null)
      {
        this.partidosJugados.set(element.$key,element)
      }
    });
 

    
  });
}
  getJugador(idJugador) {
    this.jugadorService.getJugador(idJugador).subscribe((item) => {
      // Setting up partidos del jugador
      this.jugador = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
     
      this.idQuiniela = this.jugador.id_quiniela
      //al tener el jugador, podemos tener el id de la quiniela con ello buscamos todos los partidos de esa quiniela.
      this.getPartidos(this.jugador.id_quiniela)
      this.getQuinielaById();
    })
  }

  getQuinielaById(): void {
    this.QuinielasService.getQuiniela(this.idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
      this.getQuinielas()
    });
  }


  getQuinielas() {
    this.QuinielaJugadaService.getAllPartidosByIdJugador(this.jugador.$key).subscribe((items) => {
      // Setting up partidos del jugador
      this.partidosByJugador = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as QuinielaJugada)
      );
      // Ordenar los Partidos
      this.partidosByJugador.sort((x, y) => +new Date(x.fecha) - +new Date(y.fecha));
          this.isLoading = false;
    })
  }

}
